<template>
  <nav v-if="$user.isLoggedIn()" class="navbar navbar-expand-lg navbar-menu">
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        ref="menuContainer"
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <NavigationNode :routes="routes" />
      </div>
    </div>
  </nav>
</template>

<script>
import NavigationNode from "./NavigationNode.vue";

export default {
  /*
   * Lekéri az alkalmazás elérhető útvonalait a router beállításaiból.
   */
  components: { NavigationNode },
  emits: ["navigation"],

  computed: {
    routes() {
      return this.$router.options.routes;
    },
  },
};
</script>

<style scoped>
.navbar-menu {
  background-color: #e3d496 !important;
  border: 3px solid#d3c68b;
  user-select: none;
}

.navbar-menu :deep(.navbar-toggler) {
  margin: 5px !important;
}
</style>
